import React, { useState, useEffect } from 'react';
import { useCreateRoleMutation, useRolePermissionsByIDQuery } from '../../Store/Apis/rolePermissionApi';
import Loader from '../Loader/Loader';

const RoleForm = ({roleId, permissionsList, onSubmit }) => {
    const [roleName, setRoleName] = useState('');
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [selectedPermissionsObjects, setSelectedPermissionsObjects] = useState([]);
    const [errors, setErrors] = useState({});

    const RolePermissionsByIDApi = useRolePermissionsByIDQuery(roleId, { skip: !roleId })

    useEffect(()=>{
        const selectedID = RolePermissionsByIDApi?.data?.data.permissions
        ?.filter((elem) => elem.permissionStatus !== 0)
        .map((elem) => ({
            permissionID: elem.permissionID,
            permissionsStatus: elem.permissionStatus
        }));
        setRoleName(RolePermissionsByIDApi?.data?.data.roleName);
        setSelectedPermissions(selectedID || []);
        
    },[RolePermissionsByIDApi.isSuccess])


    // Group permissions by permissionHeader
    const groupPermissions = (permissions) => {
        return permissions.reduce((groups, permission) => {
            const { permissionHeader } = permission;
            if (!groups[permissionHeader]) {
                groups[permissionHeader] = [];
            }
            groups[permissionHeader].push(permission);
            return groups;
        }, {});
    };

    // Handle permission checkbox toggle
    const handlePermissionChange = (permissionId, currentPermissionStatus) => {
        const isAlreadySelected = selectedPermissions.some(p => p.permissionID === permissionId);
    
        if (isAlreadySelected) {
            // If already selected, remove it from the selected list
            setSelectedPermissions(
                selectedPermissions.filter((p) => p.permissionID !== permissionId)
            );
        } else {
            // If not selected, add it with status `1`
            setSelectedPermissions([
                ...selectedPermissions,
                { permissionID: permissionId, permissionStatus: 1 }
            ]);
        }
    };
    


    // Form validation
    const validateForm = () => {
        const newErrors = {};
        if (!roleName) newErrors.roleName = 'Role name is required';
        if (selectedPermissions.length === 0) newErrors.permissions = 'At least one permission should be selected';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Prepare grouped permissions
    const groupedPermissions = groupPermissions(permissionsList);

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
    
        if (validateForm()) {
            // Prepare permissions list for submission
            const allPermissions = permissionsList.map((permission) => {
                const isSelected = selectedPermissions.some(
                    (p) => p.permissionID === permission.id
                );
    
                return {
                    permissionID: permission.id,
                    permissionStatus: isSelected ? 1 : 0,
                    roleID: roleId,
                };
            });
    
            // Construct the role object
            const role = {
                roleId,
                roleName: roleName,
                roleStatus: 1,
                permissions: allPermissions,
            };
            console.log(role)
            onSubmit(role);
        }
    };
    

    if(RolePermissionsByIDApi.isLoading ||RolePermissionsByIDApi.isFetching) {
        return <Loader height={400} />
    }

    return (
        <form onSubmit={handleSubmit} noValidate>
            <>
                <div className="mb-3">
                    <label htmlFor="roleName" className="form-label">Role Name</label>
                    <input
                        type="text"
                        className={`form-control ${errors.roleName ? 'is-invalid' : ''}`}
                        id="roleName"
                        value={roleName}
                        onChange={(e) => setRoleName(e.target.value)}
                    />
                    {errors.roleName && <div className="invalid-feedback">{errors.roleName}</div>}
                </div>

                <div className="mb-3">
                    <h6 className='text-muted'>Permissions</h6>
                    {Object.keys(groupedPermissions).map((header) => (
                        <>
                            
                            <div className='bg-light p-3 mb-3'>
                                <h6 className='text-sm'>{header}</h6>
                                <div className="row">
                                    {groupedPermissions[header].map((permission) => {
                                        return(
                                            <div className="col-auto" key={permission.id}>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`perm-${permission.id}`}
                                                        value={permission.id}
                                                        checked={selectedPermissions.some(p => p.permissionID === permission.id)}
                                                        onChange={() => handlePermissionChange(permission.id, permission.permissionStatus)}
                                                    />
                                                    <label className="form-check-label" htmlFor={`perm-${permission.id}`}>
                                                        {permission.permissionName}
                                                    </label>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </>
                    ))}
                    
                    {errors.permissions && <div className="invalid-feedback d-block">{errors.permissions}</div>}
                </div>

                <button type="submit" className="btn btn-primary">
                    {roleId ? 'Update Role' : 'Add Role'}
                </button>
            </>         
        </form>
    );
};

export default RoleForm;
